import i18n from './reacti18n';
import Page from './page';

export const mappingRemoteConfig = {
  callUs: 'callUs',
  email: 'email',
  liveChat: 'chat',
  chatBot: 'chat',
  messageUs: 'chat',
  chat: 'chat',
};

const isStepUpEnabled = (fromChannel) => {
  const stepUpConfig = window.stepUpConfig;
  if (typeof stepUpConfig === 'object' && typeof stepUpConfig.stepUpEnabled === 'object') {
    return stepUpConfig.stepUpEnabled[mappingRemoteConfig[fromChannel]];
  }
  return false;
};

/**
 * Function to check is topicId exists in locale property file.
 * @param topicRefId
 * @returns {boolean} true/false
 */
const isTopicSupportedForRisk = (topicRefId) => {
  const snowManCode = '%E2%98%83';
  const topicLabel = i18n.message(`smarthelp/authStepUpPrompt.${topicRefId}`);
  return !(encodeURI(topicLabel).includes(snowManCode));
};

export const isNodeChatAlreadyExists = () => {
  const nodeChatElement = document.getElementById('node-chat') || null;
  return (nodeChatElement && nodeChatElement.style.display && nodeChatElement.style.display === 'block');
};

/**
 * This will return  whether the selected topic is supported by step-up
 * This function will check whether the step-up is enabled for that channel or not in the first place and if enabled only
 * then it will check whether the selected TCode is supported for step-up or not
 *
 * @param topicRefId
 * @param fromChannel
 * @returns {boolean}
 */
export const isTopicSupportedForStepUp = (topicRefId, fromChannel) => {
  if (topicRefId && isStepUpEnabled(fromChannel)) {
    const supportedTopics = window.stepUpConfig && window.stepUpConfig.supportedTCodes;
    const locale = `${Page.getCountry().toUpperCase()}:${Page.getAPILocalilty()}`;

    // If TCode exists in remote config check the same TCode exists in property file or not.
    return (supportedTopics[topicRefId] && supportedTopics[topicRefId][locale] ? isTopicSupportedForRisk(topicRefId) : false);
  }
  return false;
};

export const isFinalIntent = (selectResultTopic) => {
  if (typeof selectResultTopic === 'object') {
    return !!(selectResultTopic && selectResultTopic.topicRefId);
  }
  return false;
};
